import React from "react";
import { Box } from "@mui/material";
import Home from "./pages/Home";
import Login from "./pages/Login";
import { SnowflakeProvider } from "./context/SnowflakeContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { FilterProvider } from "./context/FilterContext";

function AppContent() {
  console.log("app_rendered");
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <SnowflakeProvider>
      <FilterProvider>
        <Box sx={{ width: "100%" }}>
          <Box component="main" sx={{ width: "100%", p: 0 }}>
            <Home />
          </Box>
        </Box>
      </FilterProvider>
    </SnowflakeProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
